module.exports = __webpack_public_path__ + "img/le-courrier-independant.228fc832.svg";